/**
 * Pinned Intl locale for the currency and percentage inputs.
 *
 * The app formats every number it displays with a hardcoded `en-US` formatter,
 * so the inputs pin the same locale instead of following the browser's. Adding
 * a `currency` here would inject a symbol into the input's value, next to the
 * adornment the fields already render.
 */
export const PINNED_NUMBER_FORMAT = { locale: 'en-US' } as const;
